import { Text } from '@mxenabled/mxui'

import Stack from '@mui/material/Stack'

import type { SxProps } from '@mui/material/styles'
import type { LegendProps } from '../../../core/types/InsightsInstanceSlotData'

export interface LegendComponentProps {
  legendItems: LegendProps[]
  legendStyle?: SxProps
}

export const Legend = ({ legendItems, legendStyle }: LegendComponentProps) => {
  return (
    <Stack
      sx={{
        alignItems: 'flex-start',
        flexDirection: 'row',
        gap: 24,
        justifyContent: 'flex-start',
        py: 4,
        width: '100%',
        ...legendStyle,
      }}
    >
      {legendItems.map(
        ({ color, label, formattedAmount }, index) =>
          label && (
            <Stack key={label ?? index} sx={{ alignItems: 'center', flexDirection: 'row', gap: 8 }}>
              <svg
                aria-hidden="true"
                aria-labelledby={index === 0 ? 'chartLegendLabel' : label}
                fill="none"
                height="12"
                role="figure"
                width="12"
              >
                <rect fill={color} height="12" rx="2" width="12" />
              </svg>
              <Text id={index === 0 ? 'chartLegendLabel' : label} variant="caption">
                {label} {formattedAmount ? `: ${formattedAmount}` : ''}
              </Text>
            </Stack>
          ),
      )}
    </Stack>
  )
}
